import { BaseService } from "core/services";
import { FacilityInventoryCountHeaderRouteService } from "application/facility-inventory/services";

class FacilityInventoryCountHeaderService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new FacilityInventoryCountHeaderRouteService());
    }

    createFacilityInventoryCountHeaderAndDetails(resource) {
        const url = this.routeService.createFacilityInventoryCountHeaderAndDetails(resource);
        return this.apiClient.post(url, resource);
    }

    createNikoFacilityInventoryCountHeaderAndDetails(resource) {
        const url = this.routeService.createNikoFacilityInventoryCountHeaderAndDetails(resource);
        return this.apiClient.post(url, resource);
    }

    async changeIsDone(resource) {
        const url = this.routeService.changeIsDone(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    uploadFile(facilityInventoryCountHeaderId, resource) {
        const formData = new FormData();
        formData.append("file", resource.file);
        const url = this.routeService.uploadFile(facilityInventoryCountHeaderId, formData);

        return this.apiClient.put(url, formData);
    }
}

export default FacilityInventoryCountHeaderService;